import * as React from "react";

// Deep-scan JSX children for a Radix Title/Description so our dialog wrappers can
// inject a screen-reader-only fallback when a call site forgot one.
export function containsElementOfType(children, types) {
  let found = false;
  const walk = (nodes) => {
    React.Children.forEach(nodes, (child) => {
      if (found || !React.isValidElement(child)) return;
      if (types.includes(child.type)) {
        found = true;
        return;
      }
      if (child.props?.children) walk(child.props.children);
    });
  };
  walk(children);
  return found;
}

export const FALLBACK_DIALOG_TITLE = "Dialoogvenster";
export const FALLBACK_DIALOG_DESCRIPTION =
  "Gebruik de knoppen in dit venster om verder te gaan of te annuleren.";
